// Entry point, bundled by esbuild into app/assets/builds/application.js.
import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";

import "./controllers";

ActiveStorage.start();
